module.exports = __webpack_public_path__ + "img/icon_manejo_coordinacion_evaluacion.c79ec4f4.svg";